import { render, staticRenderFns } from "./Hierarquia.vue?vue&type=template&id=63a9c4d9&scoped=true&"
import script from "./Hierarquia.vue?vue&type=script&lang=js&"
export * from "./Hierarquia.vue?vue&type=script&lang=js&"
import style0 from "./Hierarquia.vue?vue&type=style&index=0&id=63a9c4d9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a9c4d9",
  null
  
)

export default component.exports